// extracted by mini-css-extract-plugin
export default {"flex_item":"info_flex_item__mUgTA","contact_item":"info_contact_item__yl16y","icon":"info_icon__EY27P"};